angular.module('lf.common')

.factory('subscriptionService', function ($http, accountService) {
  var subscriptionService = {

    loginUser: function loginUser (params) {
      var postData = {
        login: params.login,
        password: params.password
      }
      
      return $http({
        method: 'POST',
        url: lf.data.xhr.siteBaseUrl + '/xhr/subscription/loginAjax.jsp',
        data: $.param(postData),
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },
  
    addOrUpdateCard: function addOrUpdateCard (params) {
      console.log('subscriptionService addOrUpdateCard fn invoked', params);
      params.flow = 'subscription';
      return accountService.addOrUpdateCard(params);
    },
    
    cancelMembership: function (params) {
      return $http.get(lf.data.xhr.siteBaseUrl + '/xhr/subscription/cancelMembershipAjax.jsp');
    },

    restartMembership: function (params) {
      return $http.get(lf.data.xhr.siteBaseUrl + '/xhr/subscription/restartMembershipAjax.jsp');
    },
    
    downloadApp: function downloadApp (app) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.siteBaseUrl + '/xhr/subscription/productDownloadAjax.jsp',
        data: $.param({
          skuId: app.skuId
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },
    
    removeApp: function removeApp (app) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.siteBaseUrl + '/xhr/subscription/removeAppAjax.jsp',
        data: $.param({
          skuId: app.skuId,
          packageId: app.packageId
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
  };
  
  return subscriptionService;
});
